import React from "react";
import { observer } from "mobx-react";
import { CollectiveManagementSocietyViewStore } from "../../store";
import { CollectiveManagementSocietyViewForm } from "./CollectiveManagementSocietyViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type CollectiveManagementSocietyViewProps = {
  collectiveManagementSocietyViewStore: CollectiveManagementSocietyViewStore;
};

export const CollectiveManagementSocietyView: React.FC<CollectiveManagementSocietyViewProps> =
  observer(({ collectiveManagementSocietyViewStore }) => {
    return (
      <div>
        <CollectiveManagementSocietyViewForm
          name={collectiveManagementSocietyViewStore.nameValue}
          acronym={collectiveManagementSocietyViewStore.acronymValue}
          countryValue={collectiveManagementSocietyViewStore.countryValue}
          onPrint={(handlePrint: () => void) =>
            collectiveManagementSocietyViewStore.printCollectiveManagementSociety(
              handlePrint
            )
          }
          onCancel={() =>
            collectiveManagementSocietyViewStore.cancelCollectiveManagementSociety()
          }
          onEdit={
            collectiveManagementSocietyViewStore.isEditEnabled
              ? () =>
                  collectiveManagementSocietyViewStore.editCollectiveManagementSociety()
              : undefined
          }
        />
        <ErrorDialog
          open={collectiveManagementSocietyViewStore.errorDialogOpened}
          title={collectiveManagementSocietyViewStore.errorTitle}
          description={collectiveManagementSocietyViewStore.errorDescription}
          onClose={() =>
            collectiveManagementSocietyViewStore.closeErrorDialog()
          }
        />
      </div>
    );
  });
